'use strict';

module.exports = function (response) {

  if (typeof axios !== 'undefined') return response.data;

  return response;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-response-data.js
// module id = 2177
// module chunks = 2